import {
  API_DICTIONARY,
  HTTP_METHODS,
  ResponseWithPagination
} from '../../../constants'
import { ILedByGPO } from '../../../redux/store/adminSplitFees/types'
import Fetcher from '../../../services/Fetcher'
import { LedByCommunityData } from './Community/types'
import { TFormEditFees } from './GPO/types'

const fetcher = new Fetcher({})

export type AdminSplitFeesListRequestArgs = {
  limit?: number
  offset?: number
  search?: string
}

export const getLedByGPOListRequestAsync = async (
  params: AdminSplitFeesListRequestArgs
) => {
  return fetcher.request<unknown, ResponseWithPagination<ILedByGPO>>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.ADMIN_FEE_DASHBOARD}${API_DICTIONARY.LED_BY_GPO}`,
    method: HTTP_METHODS.GET,
    params
  })
}

export const getLedByCommunityList = async (
  params?: AdminSplitFeesListRequestArgs
) => {
  return fetcher.request<unknown, ResponseWithPagination<LedByCommunityData>>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.ADMIN_FEE_DASHBOARD}${API_DICTIONARY.LED_BY_COMMUNITY}`,
    method: HTTP_METHODS.GET,
    params
  })
}

export const editFeesGPO = async (id: string, data: TFormEditFees) =>
  fetcher.request<unknown, TFormEditFees>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.SPLIT_FEES}${API_DICTIONARY.GPO}${id}/`,
    method: HTTP_METHODS.PUT,
    data
  })
